/**
 * アバターの説明文
 */

const AvatarDescription = () => {
  return (
    <div className='bg-gray-50 p-3 text-[10px]'>
      <p>
        ・<b>画像サイズ: </b>10MB以下の画像を使用してください。
        <br />・<b>対応ファイル形式: </b>「jpeg」「jpg」「png」「gif」形式の画像が設定できます。
      </p>
    </div>
  );
};

export default AvatarDescription;
